import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import API from "../../../Network/API";
import { DELETE_MY_COURSE_ROUTE, MY_COURSE_FETCH_START, MY_COURSE_FETCH_SUCCESS, MY_COURSE_TOTAL_PAGE } from "../../../Reducer/myCourseSlice";
import PostLoader from '../../../assets/loader.gif';
import { useTranslation } from "react-i18next";

export default function TutorCourse() {
  const { t } = useTranslation();
  const select_course = useSelector((state) => state.myCourseReducer);
  const [isLoading, setLoading] = useState(false);
  const [loading, setLoad] = useState(false);
  const [course_id, setCourseId] = useState(0);
  const dispatch = useDispatch();
   const location = useLocation();
    const isAppRoute = location.pathname.startsWith("/app");
  
  useEffect(() => {
    setLoad(true)
    dispatch(MY_COURSE_FETCH_START())
    API.get(`/v1/oauth/teacher/mycourses`).then((response) => {
      dispatch(MY_COURSE_FETCH_SUCCESS(response.data.data))
      dispatch(MY_COURSE_TOTAL_PAGE(response.data.data.total_page))
      setLoad(false)
    }).catch((error) => {
      setLoad(false)
    });

  }, []);

  const delete_course = (id) => {
    setCourseId(id)

    if (window.confirm(t("tutorCourse.confirm_delete"))) {
      setLoading(true)
      API.delete('/v1/oauth/teacher/course/' + id + '').then((response) => {
        setLoading(false)
        dispatch(DELETE_MY_COURSE_ROUTE(id))
      }).catch((error) => {
        setLoading(false)
      });
    }

  }
  return (
    <>

      {loading ?
        <div className='content' style={{ margin: 'auto', padding: 'auto', textAlign: 'center', height: '500px' }}>
          <img src={PostLoader} alt={t("tutorCourse.loading")} height={80} width={80} />
        </div>
        :
        <>
          <div className="dashboard-title d-flex justify-content-between align-items-center">
            <h4>{t("tutorCourse.all_courses")}</h4>
            <Link to={`/dashboard/my-course/create`} className="btn btn-dark"><i className="fa-light fa-plus-circle me-1" />{t("tutorCourse.course_create")}</Link>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="tc-list">
                {!select_course?.loading && select_course?.courses?.length > 0 && select_course?.courses?.map((course) => {
                  const prefix = isAppRoute ? '/app' : '';
                  const typeLabel = course.course_type === 'recorded' ? t("tutorCourse.type_recorded")
                    : course.course_type === 'group' ? t("tutorCourse.type_group")
                    : course.course_type === '1-1' ? t("tutorCourse.type_one_on_one")
                    : course.course_type;
                  return (
                    <article className="tc-item" key={course.id}>
                      <Link to={`${prefix}/course/${course?.slug}`} className="tc-cover">
                        <img
                          src={course?.cover_image || '/assets/img/no_image.jpg'}
                          alt={course?.title || t("tutorCourse.default_title")}
                          onError={(e) => { e.target.onerror = null; e.target.src = '/assets/img/no_image.jpg'; }}
                        />
                      </Link>
                      <div className="tc-main">
                        <Link to={`${prefix}/course/${course?.slug}`} className="tc-title">{course.title}</Link>
                        <div className="tc-meta">
                          <span className={`tc-type ${course.course_type === 'recorded' ? 'is-recorded' : 'is-live'}`}>
                            <i className={`fa-light ${course.course_type === 'recorded' ? 'fa-circle-play' : 'fa-video'}`} />{typeLabel}
                          </span>
                          <span className="tc-stat"><i className="fa-light fa-users" />{t("tutorCourse.enrolled_count", { count: Number(course.total_enrollment) || 0 })}</span>
                          {course.active == 1
                            ? <span className="status-badge ok">{t("tutorCourse.published")}</span>
                            : <span className="status-badge muted">{t("tutorCourse.unpublished")}</span>}
                        </div>
                      </div>
                      <div className="tc-actions">
                        <Link to={`${prefix}/dashboard/my-course/sections/${course.id}`} className="tc-btn tc-btn-primary">
                          <i className="fa-light fa-plus" />{t("tutorCourse.add_lessons")}
                        </Link>
                        <Link to={`${prefix}/dashboard/my-course/view/${course?.id}`} className="tc-icon" title={t("tutorCourse.view")} aria-label={t("tutorCourse.view")}><i className="fa-light fa-eye" /></Link>
                        <Link to={`${prefix}/dashboard/my-course/edit/${course?.id}`} className="tc-icon" title={t("tutorCourse.edit")} aria-label={t("tutorCourse.edit")}><i className="fa-light fa-pen-to-square" /></Link>
                        {course_id == course?.id && isLoading
                          ? <span className="tc-icon"><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /></span>
                          : <button type="button" onClick={() => delete_course(course?.id)} className="tc-icon is-danger" title={t("tutorCourse.delete")} aria-label={t("tutorCourse.delete")}><i className="fa-light fa-trash-can" /></button>}
                      </div>
                    </article>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}